/* ==========================================================================
   THE ARRAN GIFT BOX — Custom Brand JS
   Handles scroll-reveal animations for the custom sections.
   Safe to load on every page; does nothing if no .agb-rv elements exist.
   ========================================================================== */
(function () {
  'use strict';

  /* Tell the CSS that JS is alive. Until this runs, .agb-rv content stays
     fully visible, so a missing or blocked script can never hide anything. */
  document.documentElement.classList.add('agb-js');

  function reveal(root) {
    var items = (root || document).querySelectorAll('.agb-rv:not(.is-in)');
    if (!items.length) return;

    // Reduced motion or no IntersectionObserver: show everything immediately.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-agb-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function init() { reveal(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is added/reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
})();
